import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class LookupsService {
    constructor(private http: HttpClient) { }

    getSpecificSystemDefaults(codes: string) {
        return this.http.get(`${environment.apiUrl}/Lookup/SpecificSystemDefaults?codes=${codes}`);
    }

    getAdmissionsApplicationSteps() {
        return this.http.get(`${environment.apiUrl}/Lookup/AdmissionsApplicationSteps`);
    }

    getAdmissionsApplicationTypes() {
        return this.http.get(`${environment.apiUrl}/Lookup/AdmissionsApplicationTypes`);
    }

    getCountries() {
        return this.http.get(`${environment.apiUrl}/Lookup/Countries`);
    }

    getStates() {
        return this.http.get(`${environment.apiUrl}/Lookup/States`);
    }

    getLanguages() {
        return this.http.get(`${environment.apiUrl}/Lookup/Languages`);
    }

    getGenderTypes() {
        return this.http.get(`${environment.apiUrl}/Lookup/GenderTypes`);
    }

    getSemesters() {
        return this.http.get(`${environment.apiUrl}/Lookup/Semesters`);
    }

    getAdmissionsApplicationStudyAreas() {
        return this.http.get(`${environment.apiUrl}/Lookup/AdmissionsApplicationStudyAreas`);
    }

    getAdmissionsApplicationSources() {
        return this.http.get(`${environment.apiUrl}/Lookup/AdmissionsApplicationSources`);
    }

    getAdmissionsSchools(providerTypIds: number[], includeNotActive: boolean) {
        let providerTypIdsParam = null;

        if (providerTypIds) {
            for (let i = 0; i < providerTypIds.length; i++) {
                if (i === 0)
                    providerTypIdsParam = `providerTypeIds=${providerTypIds[i]}`;
                else
                    providerTypIdsParam += `&providerTypeIds=${providerTypIds[i]}`;
            }
        }

        return this.http.get(`${environment.apiUrl}/Lookup/AdmissionsSchools?includeNotActive=${includeNotActive}&${providerTypIdsParam}`);
    }

    getStudentEmergencyContactTypes() {
        return this.http.get(`${environment.apiUrl}/Lookup/StudentEmergencyContactTypes`);
    }

    getEducationLevels() {
        return this.http.get(`${environment.apiUrl}/Lookup/EducationLevels`);
    }

    getHousingApplicationLifestyleQuestions() {
        return this.http.get(`${environment.apiUrl}/Lookup/HousingApplicationLifestyleQuestions`);
    }
    
    getBbOrganizations(name:string) {
        return this.http.get(`${environment.apiUrl}/Lookup/BbOrganizations?name=${name}`);
    }

    getHousingProgramsByDate() {
        return this.http.get(`${environment.apiUrl}/Lookup/HousingProgramsByDate`);
    }

    getHousingCheckinLocations() {
        return this.http.get(`${environment.apiUrl}/Lookup/HousingCheckinLocations`);
    }

    getPrograms() {
        return this.http.get(`${environment.apiUrl}/Lookup/Programs`);
    }

    getIdentityDocumentTypes() {
        return this.http.get(`${environment.apiUrl}/Lookup/IdentityDocumentTypes`);
    }

    getItalianMunicipalities(description: string) {
        return this.http.get(`${environment.apiUrl}/Lookup/ItalianMunicipalities?description=${description}`);
    }
}